const checkPlanOnExpired = (userPlan: TUserPlan): boolean =>
  userPlan === 'None' || userPlan === 'Expired';

export default checkPlanOnExpired;
